export const MAX_INT = 9007199254740992;

export const sqrtTwo = Math.sqrt(2);
